import { api } from "@/config/api";
import * as Sentry from "@sentry/react-native";
import type { AxiosError } from "axios";
import { CheckoutFailReason } from "ipctg-inflow-types/InFlowEnums";

import type { ParkPaymentIntentPOSTErrorResponse, ParkPaymentIntentPOSTRequest, ParkPaymentIntentPOSTSuccessResponse } from "ipctg-inflow-types/InFlowParkAPI";
import { Platform } from "react-native";

export const getPaymentIntent = async (requestData: ParkPaymentIntentPOSTRequest): Promise<ParkPaymentIntentPOSTSuccessResponse> => {
  try {
    const response = await api.post<ParkPaymentIntentPOSTSuccessResponse>("/payment-intent", requestData);
    return response.data;
  } catch (error) {
    Sentry.captureException(error, {
      extra: {
        data: requestData,
        localStorage: Platform.OS === "web" ? window.localStorage : null,
      },
    });
    const axiosError = error as AxiosError<ParkPaymentIntentPOSTErrorResponse>;
    throw axiosError.response?.data ?? { failReason: CheckoutFailReason };
  }
};
